import { ValidationError, object, string } from 'yup'
import * as yup from 'yup'

import { VerifyCPFCNPJ } from 'utils/utils'

import { VerifyPhone } from '../../../redux/api/location'
import { GetCurrentConsumer } from '../../../redux/api/user'

const VerifyPhoneNumber = async (n) => {
    let id
    try {
        const response = await GetCurrentConsumer()
        id = response?.id ?? ''

        if (id) {
            const res = await VerifyPhone(n, id)
            return res.success
        }
    } catch (error) {
        console.log(error)
    }
}

export const validationSchema = (isEmancipated) => {
    return object()
        .shape({
            cpf: string().nullable(),
            name: string().nullable().required('obrigatório'),
            dateOfBirth: string()
                .nullable()
                .required('obrigatório')
                .test('age', 'Idade mínima 18 anos', function (value) {
                    if (isEmancipated) return true
                    if (!value) return false

                    const cpf = this?.parent?.cpf
                    const rawCpf = cpf ? cpf.replace(/[.\-\/\s]/g, '') : ''
                    const isCnpj = rawCpf.length > 11
                    if (isCnpj) return true

                    let birthDate

                    if (
                        typeof value === 'string' &&
                        value.match(/^\d{2}\/\d{2}\/\d{4}$/)
                    ) {
                        const [day, month, year] = value
                            .split('/')
                            .map(Number)
                        birthDate = new Date(year, month - 1, day)
                    } else {
                        birthDate = new Date(value)
                    }

                    if (isNaN(birthDate.getTime())) return false

                    const today = new Date()
                    let age = today.getFullYear() - birthDate.getFullYear()
                    const monthDiff = today.getMonth() - birthDate.getMonth()

                    if (
                        monthDiff < 0 ||
                        (monthDiff === 0 &&
                            today.getDate() < birthDate.getDate())
                    ) {
                        age--
                    }

                    return age >= 18
                }),
            email: string()
                .nullable()
                .email('E-mail inválido')
                .required('obrigatório')
                .typeError('obrigatório'),
            phoneNumber2: string()
                .nullable()
                .required('obrigatório')
                .typeError('obrigatório')
                .test(
                    'valid',
                    'Celular deve ter 11 dígitos',
                    (x) => x && x.replace(/[^\d]+/g, '').length > 10,
                )
                .test('valid', 'Número de celular invalido', (x) => {
                    if (x) {
                        let rawValue = x.replace(/[^\d]+/g, '')
                        return (
                            rawValue &&
                            rawValue.substring(2, 3) >= 6 &&
                            rawValue.substring(2, 3) <= 9
                        )
                    }
                }),
            // .test('valid', 'Celular duplicado', (x) => {
            // 	if (x) {
            // 		if (x.replace(/[^\d]+/g, '').length > 10) {
            // 			return VerifyPhoneNumber(x)
            // 		}
            // 	}
            // }),
            zipCode: string()
                .nullable()
                // .matches(/^([0-9]{5}-[0-9]{3})|([0-9]{8})/)
                .required('obrigatório'),
            stateId: string().required('obrigatório').nullable(),
            location: string().required('obrigatório').nullable(),
            cityId: string().required('obrigatório').nullable(),
            // aditionalInfoForm: string().required(),
            repName: string()
                .nullable()
                .when('cpf', (cpf, repName) =>
                    cpf && cpf.replace(/[.\-\/\s]/g, '').length > 11
                        ? string().required('obrigatório')
                        : repName,
                ),
            repCpf: string()
                .nullable()
                .when('cpf', (cpf, repCpf) =>
                    cpf && cpf.replace(/[.\-\/\s]/g, '').length > 11
                        ? string().required('obrigatório')
                        : repCpf,
                ),
            repEmail: string()
                .nullable()
                .when('cpf', (cpf, repEmail) =>
                    cpf && cpf.replace(/[.\-\/\s]/g, '').length > 11
                        ? string().email('inválido').required(' obrigatório')
                        : repEmail,
                ),
            repPhoneNumber: string()
                .nullable()
                .when('cpf', (cpf, repPhoneNumber) =>
                    cpf && cpf.replace(/[.\-\/\s]/g, '').length > 11
                        ? string().required(' obrigatório')
                        : repPhoneNumber,
                ),
            district: string().required('obrigatório').nullable(),
            number: string().required('obrigatório').nullable(),
            isMEI: yup.boolean().nullable(),
        })
        .test('repCpfInvalido', null, (obj) => {
            if (
                (obj.cpf && obj.cpf.replace(/[.\-\/\s]/g, '').length <= 11) ||
                (obj.repCpf && VerifyCPFCNPJ(obj.repCpf))
            ) {
                return true
            } else {
                return new ValidationError('inválido', null, 'repCpf')
            }
        })
};

export const validationSchema_Account = object().shape(
    {
        pixKeyType: string()
            .nullable()
            .when('agency', (agency, schema) => {
                if (agency) {
                    return schema.notRequired()
                } else {
                    return schema.required('obrigatório')
                }
            })
            .when('bank', (bank, schema) => {
                if (bank) {
                    return schema.notRequired()
                } else {
                    return schema.required('obrigatório')
                }
            })
            .when('account', (account, schema) => {
                if (account) {
                    return schema.notRequired()
                } else {
                    return schema.required('obrigatório')
                }
            }),

        pixKey: string()
            .nullable()
            .when('agency', (agency, schema) => {
                if (agency) {
                    return schema.notRequired()
                } else {
                    return schema.required('obrigatório')
                }
            })
            .when('bank', (bank, schema) => {
                if (bank) {
                    return schema.notRequired()
                } else {
                    return schema.required('obrigatório')
                }
            })
            .when('account', (account, schema) => {
                if (account) {
                    return schema.notRequired()
                } else {
                    return schema.required('obrigatório')
                }
            }),

        //se pix key for preenchido, os outros campos nao podem ser obrigatorios
        bankType: string().when('pixKey', (pixKey, schema) => {
            if (pixKey) {
                return schema.notRequired()
            } else {
                return schema.required('obrigatório')
            }
        }).nullable(),

        bank: string().when('bankType', (bankType, schema) => {
            if (bankType == '0') {
                return schema.notRequired()
            } else {
                return schema.required('obrigatório')
            }
        }).nullable(),
        // numberDigit: string().when('bankType', (bankType, schema) => {
        //     if (bankType == '0') {
        //         return schema.notRequired()
        //     } else {
        //         return schema.required('obrigatório')
        //     }
        // }).nullable(),

        agency: string().when('bankType', (pix, schema) => {
            if (pix == '0') {
                return schema.notRequired()
            } else {
                return schema.required('obrigatório')
            }
        }).nullable(),

        account: string().when('bankType', (Key, schema, value) => {
            if (Key == '0') {
                return schema.notRequired()
            } else {
                return schema.notRequired().required('Obrigatório.').min(6, 'Mínimo de 5 caracteres.')
            }
        }),
    },
    [
        ['pixKey', 'bank'],
        ['pixKey', 'agency'],
        ['pixKey', 'account'],
        ['pixKeyType', 'bank'],
        ['pixKeyType', 'agency'],
        ['pixKeyType', 'account'],
    ],
)
